<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div class="tit">
      <p>
        Declaração completa de Imposto de Renda do último ano para o avalista do empréstimo.
        <a href="https://ajuda.iouu.com.br/hc/pt-br/articles/360006108993" target="_blank" class="infos">
          <at-popover trigger="hover" placement="right" content="Dúvidas? Clique aqui!">
            <i class="fas fa-info-circle"></i>
          </at-popover>
        </a>
        <br/>
        Caso haja mais de um avalista acrescente sua declaração de IR.
      </p>
    </div>
    <form>
      <div class="margin">
        <files-input :files="arquivos" :accept="formatosAceitos"
          :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
      </div>
      <!-- <div class="text-center">
        <small>
          *O(s) avalista(s) é aquele que assume a dívida e pode ser acionado diretamente pelos investidores em caso de inadimplência da empresa. Idealmente é o sócio majoritário
        </small>
      </div> -->
      <div class="fixedOptions">
        <button @click="onSubmit" class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
  p.files {
    font-size: 12px!important;
    padding: 20px 0;
  }

  .margin {
    margin-bottom: 25px;
  }

  .infos i {
    color: #999;
  }
</style>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosIrpf || [null]
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    removeFile(index) {
      this.arquivos.splice(index, 1)
    },
    clearFile(index) {
      this.$set(this.arquivos, index, null)
    },
    validate() {
      if(this.arquivosRecebidos.length > 0) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio do IRPF de ao menos um avalista é obrigatório']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()

      if(validation.isValid) {
        const newData = {
          ArquivosIrpf: this.arquivosRecebidos
        }
        this.$emit('on-submit', newData)
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/EnvioIrpfPasso.vue